import {AbstractControl, UntypedFormArray, UntypedFormControl, UntypedFormGroup} from "@angular/forms";
import moment from "moment";

export class Utils {
  static passPattern = '(?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{8,30}';
  static emailPattern = '[А-Яа-яA-Za-z0-9._%+-]+@[А-Яа-яA-Za-z0-9.-]+\\.[А-Яа-яA-Za-z]{2,}$';
  static customPatterns = {
    'E': // символы (в том числе русские) или цифры
      {
        pattern: new RegExp('[а-яА-ЯA-Za-z0-9]')
      },
    'L': // латинские буквы, цмфры и спецсимволы (без русских букв и пробела)
      {
        pattern: new RegExp('[^а-яА-Я ]')
      }
  };
  static floatPattern = '(([1-9][0-9]{0,19})(\.[0-9]{1,2})?)';

  static padNumber(num) {
    let s = num + "";
    while (s.length < 2) {
      s = "0" + s;
    }
    return s;
  }

  /**
   * Метод позволяющий сравнить сегодняшную дату
   * с датой выхода валюты из денежного оборащения.
   * @param dateValue - строка в формате yyyymmdd
   */
  static dateNowIsAfter(dateValue: string) {
    if (!dateValue) {
      return false;
    }
    const dateCurrency = moment(dateValue, "YYYY-MM-DD").format();
    return moment().isAfter(dateCurrency);
  }

  static goBack() {
    history.back();
  }

  static scrollTopSmooth() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  /**
   * Копия объекта
   * @param obj - объект
   */
  static clone(obj): any {
    return JSON.parse(JSON.stringify(obj));
  }


  static getFileNameFromContentDisposition(response: any) {
    let result: string;
    try {
      const fileName = response.headers.get('Content-Disposition');
      result = fileName.split(';')[1].trim().split('=')[1];
      result = result.replace(/"/g, '');
      result = result.replace(/\+/g, ' ');
    } catch (e) {
      console.warn(e);
      result = 'file';
    }
    return result;
  }

  /**
   * Разворачиваем дату dd/mm/yyyy => yyyy.mm.dd
   */
  static revertDate(data, sepIn, sepOut) {
    let result = '';
    if (data) {
      result = data.split(sepIn);
      result = `${ result[2] }${ sepOut }${ result[1] }${ sepOut }${ result[0] }`;
    }
    return result;
  }

  /**
   * Удаление ключей объектов
   * @param obj - объект
   * @param keyToDel - имя или список имен ключа для удаления
   */
  static removeKeysFromObj(obj: any, keyToDel: string | Array<string>) {
    Object.keys(obj).forEach(key => {
      if (Array.isArray(keyToDel) && keyToDel.includes(key) || key === keyToDel) {
        delete obj[key];
      } else {
        const value = obj[key];
        if (Array.isArray(value)) {
          value.forEach(item => {
            if (item instanceof Object) {
              this.removeKeysFromObj(item, keyToDel);
            }
          });
        } else {
          if (value instanceof Object) {
            this.removeKeysFromObj(value, keyToDel);
          }
        }
      }
    });
  }

  static deleteEmptyObj(data, isForm?: boolean): number | void {
    let amountNullFields = 0;
    Object.keys(data).forEach(key => {
      const obj = data[key];
      if (obj instanceof Object) {
        if (Array.isArray(obj)) {
          if (obj.length > 0) {
            for (let i = 0; i < obj.length;) {
              const amountFieldsBeforeEditing = Object.keys(obj[i]).length;
              const amountNullFieldsAfterEditing = this.deleteEmptyObj(obj[i], isForm);
              // Если объект списка стал пустым - удаляем
              if (obj.length === 0) {
                break;
              } else if (Object.keys(obj[i]).length === 0
                || amountFieldsBeforeEditing === amountNullFieldsAfterEditing) {
                amountNullFields++;
                obj.splice(i, 1);
              } else {
                i++;
              }
            }
          }
          // если пустой массив - удаляем
          if (obj.length === 0) {
            !isForm
              ? delete data[key]
              : amountNullFields++;
          }
        } else {
          const amountFieldsBeforeEditing = Object.keys(obj).length;
          // Запускаем проверку объекта
          const amountNullFieldsAfterEditing = this.deleteEmptyObj(obj, isForm);
          // Внутри объекта все удалилось
          if (Object.keys(obj).length === 0
            || amountFieldsBeforeEditing === amountNullFieldsAfterEditing) {
            if (!isForm) {
              delete data[key];
            } else {
              data[key] = null;
              amountNullFields++;
            }
          }
        }
      } else {
        // Если пустая строка - удаляем (для форм - подсчитываем количество нулевых полей)
        if (obj === '' || obj === null || obj === undefined || (isForm && obj === 0)) {
          !isForm
            ? delete data[key]
            : amountNullFields++;
        }
      }
    });

    if (isForm) {
      return amountNullFields;
    }
  }

  static encodeJSONBase64(data) {
    const value = JSON.stringify(data);
    return btoa(unescape(encodeURIComponent(value)));
  }

  static decodeJSONBase64(data) {
    const value = decodeURIComponent(escape(atob(data)));
    return JSON.parse(value);
  }

  /**
   * Сортировка ключей объекта
   * @param data - объект для сортировки
   */
  static sortObjectKey(data) {
    const sortObject = o => Object.keys(o).sort().reduce((r, k) => (r[k] = o[k], r), {});
    if (data instanceof Object) {
      data = sortObject(data);
    }
    Object.keys(data).forEach(key => {
      const obj = data[key];
      if (obj instanceof Object) {
        if (Array.isArray(obj)) {
          (obj as Array<any>).forEach((item, index: number) => {
            data[key][index] = this.sortObjectKey(item);
          });
        } else {
          data[key] = this.sortObjectKey(obj);
        }
      }
    });
    return data;
  }

  static checkBrowser() {
    var ua = navigator.userAgent, tem, M = ua.match(
      /(opera|yabrowser|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return { name: 'IE', version: (tem[1] || '') };
    }
    if (M[1] === 'Chrome') {
      tem = ua.match(/\b(OPR|Edg|YaBrowser)\/(\d+)/);
      if (tem != null) {
        return { name: tem[1].replace('OPR', 'Opera'), version: tem[2] };
      }
    }
    M = M[2]
      ? [M[1], M[2]]
      : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) {
      M.splice(1, 1, tem[1]);
    }
    return { name: M[0], version: M[1] };
  }

  static formatBytes(bytes, decimals = 2) {
    if (!+bytes) {
      return '0 байт';
    }

    const k = 1024;
    const dm = decimals < 0
      ? 0
      : decimals;
    const sizes = ['байт', 'Кб', 'Мб', 'Гб', 'Тб'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return `${ parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) }${ sizes[i] }`;
  }

  static searchByCodeOrName() {
    return this.searchByFieldsFn(['code', 'name']);
  }

  static searchByFieldsFn(fields: string[]) {
    /**
     * @param term - строка поиска из select
     * @param item - элемент списка
     */
    return (term: string, item: any) => {
      if (term && item) {
        term = term.toLocaleLowerCase();
        return Array.from(fields).some(searchField => {
          return item[searchField].toLocaleLowerCase().indexOf(term) != -1;
        });
      }
      return true;
    };
  }

  static getDateAsNgbStructDate(date: Date): {year: string, month: string, day: string} {
    return {
      year: String(date.getFullYear()),
      month: String(date.getMonth() + 1).padStart(2, '0'),
      day: String(date.getDate()).padStart(2, '0'),
    };
  }

  static getDiffDate(privateNotAfter: string, unitTime: 'minutes' | 'days'): number {
    const dateAfter = moment(privateNotAfter, "DD.MM.YYYY HH:mm:ss", "Europe/Moscow");
    return moment(dateAfter.toISOString()).diff(moment(), unitTime, true);
  }

  static getTextTable(privateNotBefore: string, privateNotAfter: string): string {
    const [dateBefore, timeBefore] = privateNotBefore.split(' ');
    const [dateAfter, timeAfter] = privateNotAfter.split(' ');
    return this.getIsValidKey(privateNotAfter) ? `Действителен с ${dateBefore} (${timeBefore}) по ${dateAfter} (${timeAfter})` :
        `Закрытый ключ истёк ${dateAfter} (${timeAfter})`;
  }

  static getClassForRow(privateNotAfter: string): string {
    const diffDays = this.getDiffDate(privateNotAfter, 'days');
    return diffDays < 14 ? 'color-red' : 'color-green';
  }

  static getIsValidKey(privateNotAfter: string): boolean {
    const diffMin = this.getDiffDate(privateNotAfter, 'minutes');
    return diffMin > 0;
  }
}

/**
 * функция копирования контролла
 * @param control - откуда копируем
 */
export function cloneAbstractControl<T extends AbstractControl>(control: T): T {
  let newControl: T;
  if (control instanceof UntypedFormGroup) {
    const formGroup = new UntypedFormGroup({}, control.validator, control.asyncValidator);
    const controls = control.controls;
    Object.keys(controls).forEach(key => {
      formGroup.addControl(key, cloneAbstractControl(controls[key]));
    });
    newControl = formGroup as any;
  } else if (control instanceof UntypedFormArray) {
    const formArray = new UntypedFormArray([], control.validator, control.asyncValidator);
    control.controls.forEach(formControl => formArray.push(cloneAbstractControl(formControl)));
    newControl = formArray as any;
  } else if (control instanceof UntypedFormControl) {
    newControl = new UntypedFormControl(control.value, control.validator, control.asyncValidator) as any;
  } else {
    throw new Error('Error: unexpected control value');
  }
  if (control.disabled) {
    newControl.disable({ emitEvent: false });
  }
  return newControl;
}
